export const isPdf = (filename) => {
  const fileNameSplitted = filename?.split(".");
  return fileNameSplitted && fileNameSplitted.length > 0 && fileNameSplitted[fileNameSplitted.length - 1]?.toLowerCase() === "pdf" 
}

export default isPdf;